import * as React from 'react';
import classnames from 'classnames';

import { Link } from '../../../common/Link';
import { useIsMobileDevice } from '../../../../hooks';

import blockIconSrc from './assets/block.png';
import * as styles from './SubAgentMasterLimitExceed.css';

interface IProps {
  handleClick(): void;
}

export const SubAgentMasterLimitExceed = ({ handleClick }: IProps) => {
  const isMobile = useIsMobileDevice();

  return (
    <div className={classnames(styles['wrapper'], isMobile && styles['mobile'])}>
      <div className={styles['icon']}>
        <img width={28} height={28} src={blockIconSrc} />
      </div>

      <div className={styles[isMobile ? 'mobile-content' : 'desktop-content']}>
        <div className={styles['text']}>
          Агентство ограничило вам публикации.
          <br />
          Переключитесь на личный счёт, чтобы разместить объявление.
        </div>

        <div>
          <Link onClick={handleClick}>Переключиться</Link>
        </div>
      </div>
    </div>
  );
};
